/*
 * @Descripttion:
 * @version:
 * @Author: 邓旭阳
 * @Date: 2022-01-17 10:02:27
 * @LastEditors: 邓旭阳
 * @LastEditTime: 2022-02-21 11:11:57
 */
import Environment from './Environment';
// const LOGIN_HEADER = '';
// const BigDataIframeSrc = '';
// const PAY_HEADER = '';

export default {
    // 用户接口
    getTableData: Environment.USER_HEADER + '/user/query',

    // 预案接口
    getPlanData: Environment.API_HEADER + '/plan/query',
    addPlanData: Environment.API_HEADER + '/plan/add',
    modifyPlanData: Environment.API_HEADER + '/plan/modify',
    deletePlanData: Environment.API_HEADER + '/plan/delete',
    getPlannodeData: Environment.API_HEADER + '/plannode/query',
    addPlannodeData: Environment.API_HEADER + '/plannode/add',
    modifyPlannodeData: Environment.API_HEADER + '/plannode/modify',
    deletePlannodeData: Environment.API_HEADER + '/plannode/delete',
    getPlanrunData: Environment.API_HEADER + '/planrun/query',
    addPlanrunData: Environment.API_HEADER + '/planrun/add',
    modifyPlanrunData: Environment.API_HEADER + '/planrun/modify',
    deletePlanrunData: Environment.API_HEADER + '/planrun/delete',
    getPlanrunnodeData: Environment.API_HEADER + '/planrunnode/query',
    addPlanrunnodeData: Environment.API_HEADER + '/planrunnode/add',
    modifyPlanrunnodeData: Environment.API_HEADER + '/planrunnode/modify',
    deletePlanrunnodeData: Environment.API_HEADER + '/planrunnode/delete',
    getplanrundetailData: Environment.API_HEADER + '/planrundetail/query',
    getPlanstatisticsData: Environment.API_HEADER + '/planstatistics/query',
    UpdataPlanstatus: Environment.API_HEADER + '/planstatus/update',
    getReportType:Environment.API_HEADER+"/eventinfo/parent/query",
    addplanAppraise: Environment.API_HEADER + '/planrun/appraise',
    activePlanstatic:Environment.API_HEADER+'/planstatistics/active',
    // 任务接口
    getTaskData: Environment.TASK_HEADER + '/task/query',
    getTasktypeData: Environment.TASK_HEADER + '/tasktype/query',
    addTaskData: Environment.TASK_HEADER + '/task/add',
    //事件接口
    addEventmessageData: Environment.EVENT_HEADER + '/eventmessage/add',
    getDestination: Environment.EVENT_HEADER + '/eventinfo/destination/query',

}



